import PropTypes from 'prop-types';
import React from 'react';
import styles from './RadioButtons.css';
import RadioButton from './RadioButton';

const RadioButtons = ({
    input,
    values,
    className,
    radioClassName,
    meta: { touched, error, warning },
    id,
    style,
    color,
}) => (<div style={style}>
    <div className={className}>
        {values.map(({ value, label, span }) => (
            <RadioButton
                id={id}
                key={`radio-key-${value}`}
                value={value}
                label={label}
                input={input}
                span={span}
                className={radioClassName}
                color={color}
            />
        ))}
    </div>
    {touched && error ? <span className={styles.error}>{error}</span> : null}
    {touched && warning ? <span className={styles.warning}>{warning}</span> : null}
</div>);


RadioButtons.propTypes = {
    className: PropTypes.string,
    radioClassName: PropTypes.string,
    input: PropTypes.object,
    values: PropTypes.array,
    meta: PropTypes.object,
    id: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.string,
    style: PropTypes.object,
};

RadioButtons.defaultProps = {
    meta: {},
};

export default RadioButtons;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/RadioButtons/RadioButtons.js